var render = function render(){var _vm=this,_c=_vm._self._c;return _c('embryo-table',{attrs:{"id":_vm.$route.params.id,"headers":_vm.headers,"fetch":_vm.fetchEmbryos}})
}
var staticRenderFns = []

export { render, staticRenderFns }